import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { IAppConfigState, IMagicoAppData } from "../../models/AppConfigModels";

const initialState: IAppConfigState = {
  logo: "",
  static_pages: {},
  images: {},
  colors: {},
  configs: {},
};

const appConfigSlice = createSlice({
  name: "appConfig",
  initialState,
  reducers: {
    setAppConfig: (state, action: PayloadAction<IMagicoAppData>) => {      
      const { logo, static_pages, images, colors, configs } = action.payload;
      return {
        logo: logo || "",
        static_pages: static_pages || {},
        images: images || {},
        colors: colors || {},
        configs: configs || {},
      };
    },
    clearAppConfig: () => initialState,
    updateAppColors: (state, action: PayloadAction<Record<string, string>>) => {
      state.colors = { ...state.colors, ...action.payload };
    },
    updateAppImages: (state, action: PayloadAction<Record<string, string>>) => {
      state.images = { ...state.images, ...action.payload };
    },
  },
});

export const { setAppConfig, clearAppConfig, updateAppColors, updateAppImages } = appConfigSlice.actions;

// Selectors
export const selectAppConfig = (state: { appConfig: IAppConfigState }) => state.appConfig;
export const selectAppLogo = (state: { appConfig: IAppConfigState }) => state.appConfig.logo;
export const selectAppColors = (state: { appConfig: IAppConfigState }) => state.appConfig.colors;
export const selectAppImages = (state: { appConfig: IAppConfigState }) => state.appConfig.images;
export const selectAppConfigs = (state: { appConfig: IAppConfigState }) => state.appConfig.configs;

export default appConfigSlice.reducer;